<template>
  <main class="app-content" :short="true">
    <div class="m-5 pt-5">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <button class="btn btn-quaternary mb-4" v-on:click="handleBackClicked">
              Back to Audience List</button>
          </div>
          <div class="col-md-6 offset-md-3">
            <audience-form
              @on-edit-cancelled="handleEditCancelled"
              :data="editData"
              :mode="mode"
            ></audience-form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import AudienceForm from '../../components/Audience/AudienceForm';
import AudienceFormData from '../../components/Audience/AudienceForm/AudienceFormData';
import ApiCallMixin from '../../mixins/ApiCallMixin';
import AudienceServiceV2 from '../../services/V2/AudienceServiceV2';

export default {
  components: {
    AudienceForm,
  },
  mixins: [ApiCallMixin],
  data() {
    return {
      mode: 'create', // 'create' or 'edit'
      editData: null,
    };
  },
  methods: {
    handleEditCancelled() {
      this.mode = 'create';
    },
    handleBackClicked() {
      this.$router.push("/audience");
    },
    async handleEditMode(audienceId) {
      const response = await this.request(
        'GET-AUDIENCE',
        AudienceServiceV2.getAudience,
        audienceId
      );
      const data = response.data.data;
      if (data) {
        this.editData = new AudienceFormData(
          data.id,
          data.name,
          data.scope,
          data.assignments
        );
        this.mode = 'edit';
      }
    },
  },
  mounted() {
    this.registerApis(['GET-AUDIENCE']);
    const audienceId = this.$route.query.audienceId;
    if (audienceId) {
      this.handleEditMode(audienceId);
    }
  },
};
</script>
